import { projectConstants } from '../_constants';
import { redirectHomePage } from '../_helpers';

export default function projects(state = { token: true }, action) {
    switch (action.type) {

        case projectConstants.INSERT_REQUEST:
        case projectConstants.GETALL_REQUEST:
        case projectConstants.UPDATE_REQUEST:
        case projectConstants.DELETE_REQUEST:
        case projectConstants.GETALLBYUSERID_REQUEST:
            return {
                ...state,
                loading: true
            };

        case projectConstants.GETALL_SUCCESS:
        case projectConstants.GETALLBYUSERID_SUCCESS:
            return {
                ...state,
                items: action.decryptedData
            };

        case projectConstants.DELETE_SUCCESS:
            function isProjectIdMapping(project) {
                var isMapping = false;

                action.project.map(value => {
                    if (value === project.ProjectId) {
                        isMapping = true;
                    }
                    return null
                })

                return !isMapping;
            }

            return {
                ...state,
                items: state.items.filter(isProjectIdMapping)
            };

        case projectConstants.INSERT_FAILURE:
        case projectConstants.GETALL_FAILURE:
        case projectConstants.UPDATE_FAILURE:
        case projectConstants.DELETE_FAILURE:
        case projectConstants.GETALLBYUSERID_FAILURE:
            // redirectHomePage()
            return {
                ...state,
                error: action.error,
                token: false
            };

        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/_reducers/projects.reducer.js